import {
  buildPlaceOrderPayload as buildInner,
  submitPlaceOrder as submitInner,
  type PlaceOrderRequestPayload,
} from "@the-drop/customer-shared/api/place-order";

import type { CheckoutDeliveryAddress } from "./checkout-delivery-storage";
import { fetchWithClerkJwt } from "./fetch-with-clerk";
import type { CartLine } from "../store/cart-store";

/**
 * Web shim — curries the lifted helpers with `source: "platform_web"` and
 * `fetchWithClerkJwt`, preserving the original signatures so
 * `CheckoutScreen.tsx` and other call sites are unchanged.
 */
export function buildPlaceOrderPayload(args: {
  dispensaryId: string;
  address: CheckoutDeliveryAddress;
  lines: CartLine[];
  customerDeliveryFeeCents: number;
  straddlePaykey?: string;
  deliveryPaymentMethod?: "ach" | "cash_at_delivery";
}): PlaceOrderRequestPayload {
  return buildInner({ ...args, source: "platform_web" });
}

export function submitPlaceOrder(
  getToken: () => Promise<string | null>,
  idempotencyKey: string,
  body: PlaceOrderRequestPayload,
) {
  return submitInner(fetchWithClerkJwt, getToken, body, { idempotencyKey });
}

export { SubmitOrderHttpError } from "@the-drop/customer-shared/api/place-order";

export type {
  PlaceOrderLinePayload,
  PlaceOrderRequestPayload,
  PlaceOrderSuccess,
} from "@the-drop/customer-shared/api/place-order";

/** Web-only: pulls the dev-mode Straddle paykey override from `import.meta.env`. */
export function resolveStraddlePaykeyFromEnv(): string | null {
  const v = import.meta.env.VITE_STRADDLE_PAYKEY;
  if (typeof v !== "string") return null;
  const t = v.trim();
  return t.length > 0 ? t : null;
}
